/** Shared login auth hook for the four preview variants. Mirrors the two-step
 *  flow used by the production Login.jsx — email → tenant hint → password. */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";

export function useLoginAuth() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [step, setStep] = useState("email");         // email | credentials
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tenantHint, setTenantHint] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function continueEmail(e) {
    e?.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/tenant-hint", { email });
      setTenantHint(data);
      setStep("credentials");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  }

  async function submitPassword(e) {
    e?.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Unable to sign in.");
    } finally {
      setLoading(false);
    }
  }

  return {
    step, email, password, tenantHint, loading, error,
    setEmail, setPassword, continueEmail, submitPassword,
    backToEmail: () => { setStep("email"); setPassword(""); setError(""); },
  };
}
